import PropTypes from 'prop-types';
// material
import { styled } from '@mui/material/styles';
import { IconButton, Box } from '@mui/material';
// components
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const RootStyle = styled(Box)(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.down('lg')]: {
    display: 'flex',
    position: 'fixed',
    top: theme.spacing(2),
    left: theme.spacing(2),
    zIndex: theme.zIndex.appBar,
  },
}));

const MenuButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[2],
  '&:hover': {
    backgroundColor: theme.palette.background.paper,
  },
}));

// ----------------------------------------------------------------------

MobileMenuButton.propTypes = {
  onOpenSidebar: PropTypes.func,
};

export default function MobileMenuButton({ onOpenSidebar }) {
  return (
    <RootStyle>
      <MenuButton onClick={onOpenSidebar} size="medium">
        <Iconify icon="eva:menu-2-fill" width={24} height={24} />
      </MenuButton>
    </RootStyle>
  );
}
